import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage, useIntl } from 'react-intl';
import { Box, Grid } from '@material-ui/core';

import { DynoAlertModal } from 'components/dyno-template/modals';
import { BasicButton, IconButton } from 'components/common/buttons';
import { BasicModal } from 'components/common/modals';
import { Icon } from 'components/common';

import LoadingIcon from 'assets/icons/loading.gif';
import { INT_FOUR, INT_ONE } from '../../settings/constants/common';

const Coachmark = ({
  loading,
  isCoachmarkOpen,
  isCoachmarkActionOpen,
  hasRemember,
  coachmarkIndex,
  coachmarkImage,
  openCoachmark,
  handleCoachmarkPrev,
  handleCoachmarkNext,
  setLoading,
  setCoachmarkActionOpen,
  handleCoachmarkClose,
  setHasRemember,
  activeSecure2u,
  secure2u,
}) => {
  const { formatMessage } = useIntl();
  const [isNextDisabled, setIsNextDisabled] = useState(false);

  useEffect(() => {
    const shouldDisableNextButton = activeSecure2u && coachmarkIndex === INT_FOUR;
    setIsNextDisabled(shouldDisableNextButton);
  }, [activeSecure2u, coachmarkIndex]);

  const CoachmarkFooter = (
    <Box display="flex">
      <BasicButton
        className="close-btn--coachmark"
        disabledElevation
        onClick={handleCoachmarkClose}
        title={formatMessage({ id: 'buttonText.close' })}
      />
      {!secure2u && (
        <Grid container xs={12} justify="flex-end" spacing={3}>
          <Grid item>
            <IconButton isDisabled={coachmarkIndex === INT_ONE} onClick={handleCoachmarkPrev} className="btn--coachmark">
              <Icon type="chevronPrev" />
            </IconButton>
          </Grid>
          <Grid item className="ml3">
            <IconButton isDisabled={isNextDisabled} onClick={handleCoachmarkNext} className="btn--coachmark">
              <Icon type="chevronNext" />
            </IconButton>
          </Grid>
        </Grid>
      )}
    </Box>
  );

  return (
    <>
      <DynoAlertModal
        isOpen={isCoachmarkActionOpen}
        onClose={() => setCoachmarkActionOpen(false)}
        onCancel={() => setCoachmarkActionOpen(false)}
        onSubmit={openCoachmark}
        hasCancelButton
        title={formatMessage({ id: 'dashboard.coachmark.title' })}
        description={formatMessage({ id: 'dashboard.coachmark.description' })}
        actionButtonTitle={formatMessage({ id: 'buttonText.letsGo' })}
        secondaryActionButtonTitle={formatMessage({ id: 'buttonText.skip' })}
        hasCheckbox
        hasRemember={hasRemember}
        handleCheckboxClicked={setHasRemember}
        checklistLabel={<FormattedMessage id="dashboard.coachmark.checklist" />}
      />
      <BasicModal
        hasFooter
        footer={CoachmarkFooter}
        onClose={handleCoachmarkClose}
        isOpen={isCoachmarkOpen}
        className={loading ? 'coachmark--modal on-loading' : 'coachmark--modal'}
        disableBackdropClick
        hideBackdrop={!!secure2u}
        secure2u={secure2u}
      >
        <div style={{ display: loading ? 'block' : 'none' }}>
          <img src={LoadingIcon} alt="Loading..." />
        </div>
        {coachmarkImage && (
          <img
            style={{
              display: loading ? 'none' : 'block',
              width: '100%',
            }}
            onLoad={() => setLoading(false)}
            alt={`coachmark index ${coachmarkIndex}`}
            src={coachmarkImage}
          />
        )}
      </BasicModal>
    </>
  );
};

Coachmark.defaultProps = {
  loading: true,
  isCoachmarkOpen: false,
  isCoachmarkActionOpen: true,
  hasRemember: false,
  coachmarkIndex: 0,
  coachmarkImage: '',
  setLoading: null,
  setCoachmarkActionOpen: null,
  handleCoachmarkClose: null,
  setHasRemember: null,
  openCoachmark: null,
  handleCoachmarkPrev: null,
  handleCoachmarkNext: null,
  activeSecure2u: false,
  secure2u: false,
};

Coachmark.propTypes = {
  loading: PropTypes.bool,
  isCoachmarkOpen: PropTypes.bool,
  isCoachmarkActionOpen: PropTypes.bool,
  hasRemember: PropTypes.bool,
  coachmarkIndex: PropTypes.number,
  coachmarkImage: PropTypes.string,
  setLoading: PropTypes.func,
  setCoachmarkActionOpen: PropTypes.func,
  handleCoachmarkClose: PropTypes.func,
  setHasRemember: PropTypes.func,
  openCoachmark: PropTypes.func,
  handleCoachmarkPrev: PropTypes.func,
  handleCoachmarkNext: PropTypes.func,
  activeSecure2u: PropTypes.bool,
  secure2u: PropTypes.bool,
};

export default Coachmark;
